<template>
  <div class="card Firstdash-card mt-3">
    <div class="row g-0">
      <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
        <div class="card text-white Cash-card tablecard m-1">
          <div class="row ps-3 pt-3 pe-3">
            <div class="col-6 col-md-8 col-lg-8">
              <span class="heading-26 fs-5 fw-bold ps-1"
                >Cashless Enablement Acceptance Points</span
              >
            </div>
            <div class="col-6 col-md-4 col-lg-4">
              <span class="d-flex justify-content-end fs-6 fw-light heading-14"
                >Data as of {{ monthyear(cashless?.To_Date_Query) }}</span
              >
            </div>
          </div>
          <div class="row ps-3 pe-3 totalenablement">
            <div class="col- col-md-3 col-lg-3"></div>
            <div class="col-3 col-md-3 col-lg-3">
              <span
                class="d-flex justify-content-center fs-5 fw-bold heading-22 pe-4"
                >Total</span
              >
            </div>
            <div class="col-6 col-md-6 col-lg-6">
              <span
                class="d-flex justify-content-center fs-5 fw-bold heading-22"
                >Enablement This Year</span
              >
            </div>
          </div>
          <div class="row ps-3 pb-3 pe-3 g-0">
            <div class="col-6 col-md-6 col-lg-6 p-1">
              <table class="table table-bordered table1">
                <thead>
                  <tr class="head">
                    <th scope="col" class="t1-border"></th>
                    <th scope="col">Enabled</th>
                    <th scope="col">Active</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row" class="trow">Online</th>
                    <td class="tf">
                      {{ formatNumber(cashless?.total_enablement_online) }}
                    </td>
                    <td class="tf">
                      {{ formatNumber(cashless?.total_active_online) }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="trow">DuitNow QR</th>
                    <td class="tf">
                      {{ formatNumber(cashless?.total_enablement_duitnow_qr) }}
                    </td>
                    <td class="tf">
                      {{ formatNumber(cashless?.total_active_duitnow_qr) }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="trow">MyDebit</th>
                    <td class="tf">
                      {{ formatNumber(cashless?.total_enablement_mydebit) }}
                    </td>
                    <td class="tf">
                      {{ formatNumber(cashless?.total_active_mydebit) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-6 col-md-6 col-lg-6 p-1">
              <table class="table table-bordered table1">
                <thead>
                  <tr class="head">
                    <th scope="col">Enabled</th>
                    <th scope="col">Active</th>
                    <th scope="col" class="t2-border">Rural</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td scope="row" class="trow1">
                      {{ formatNumber(cashless?.enabled_online) }}
                    </td>
                    <td class="tf">
                      {{ formatNumber(cashless?.active_online) }}
                    </td>
                    <td class="tf">N/A</td>
                  </tr>
                  <tr>
                    <td scope="row" class="trow1">
                      {{ formatNumber(cashless?.enabled_duitnow_qr) }}
                    </td>
                    <td class="tf">
                      {{ formatNumber(cashless?.active_duitnow_qr) }}
                    </td>
                    <td class="tf">
                      {{ formatNumber(cashless?.rural_duitnow_qr) }}
                    </td>
                  </tr>
                  <tr>
                    <td scope="row" class="trow1">
                      {{ formatNumber(cashless?.enabled_mydebit) }}
                    </td>
                    <td class="tf">No Data</td>
                    <td class="tf">No Data</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
        <div class="card text-white Cash-card m-1">
          <div class="row ps-3 pt-3 pe-3">
            <div class="col-6 col-md-6 col-lg-6">
              <span class="heading-26 fs-4 fw-bold"
                >Ecosystem Participants</span
              >
            </div>
            <div class="col-6 col-md-6 col-lg-6">
              <span class="d-flex justify-content-end fs-6 fw-light heading-14"
                >Data as of
                {{ monthyear(ecosystemdate) }}
              </span>
            </div>
          </div>
          <div class="row chartview">
            <div id="chartdiv"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import {  config,setAuthToken} from '@/config';
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

const ecosystem = process.env.https://api.nrtdashboard.prod.inet.paynet.my/paynet/api/get-ecosystem-data;

const CashlessEnablement = process.env.https://api.nrtdashboard.prod.inet.paynet.my/paynet/api/get-cashless-enablement-data;
export default {
  name: "first-dashboard",
  components: {},

  data() {
    return {
      cashless: 0,
      ecodata: null,
      ecosystemdate: "",
    };
  },
  mounted() {
    var root = am5.Root.new("chartdiv");
    root._logo.dispose();
    root.setThemes([am5themes_Animated.new(root)]);
    var chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        startAngle: 180,
        endAngle: 360,
        layout: root.horizontalLayout,
        innerRadius: am5.percent(50),
      })
    );

    var series = chart.series.push(
      am5percent.PieSeries.new(root, {
        startAngle: 180,
        endAngle: 360,
        valueField: "value",
        categoryField: "category",
        alignLabels: true,

        labels: {
          getText: function (node) {
            return node.dataItem.properties["value"]
              .toString()
              .replace(":", ">");
          },
        },
      })
    );

    series
      .get("colors")
      .set("colors", [
        am5.color("#F7931D"),
        am5.color("#2179BE"),
        am5.color("#2A9ED2"),
        am5.color("#38b449"),
      ]);
    series.states.create("hidden", {
      startAngle: 180,
      endAngle: 180,
    });

    series.slices.template.setAll({
      cornerRadius: 5,
    });

    series.ticks.template.setAll({
      location: 1,
      stroke: am5.color("#f8f8ff"),
      strokeWidth: 2,
    });
    series.labels.template.set(
      "text",
      "[bold]{valuePercentTotal.formatNumber('0.00')}%"
    );

    var legend = chart.children.push(
      am5.Legend.new(root, {
        nameField: "name",
        fillField: "color",
        strokeField: "color",
        centerY: am5.percent(75),
        y: am5.percent(75),
        layout: root.verticalLayout,
      })
    );

    legend.labels.template.setAll({
      fill: am5.color("#ffffff"),
    });

    series.labels.template.setAll({
      fill: am5.color("#ffffff"),
    });
    this.getecosystem(series, legend);
    this.getcashlessEnablement();
  },
  unmounted() {
    if (this.root) {
      this.root.dispose();
    }
  },

  methods: {
    formatNumber(number) {
      if (number !== null && number !== undefined) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "";
      }
    },
    monthyear(dateValue) {
      let date = new Date(dateValue);
      let month = date.toLocaleString("en-US", { month: "short" });
      let year = date.getFullYear();
      return `${month} ${year}`;
    },

    async animateSeries(data, series, legend) {
      function capitalizeFirstLetter(string) {
        return string
          .split("_")
          .map((word) => {
            return word.charAt(0).toUpperCase() + word.slice(1);
          })
          .join(" ");
      }
      var i = 0;
      var interval = setInterval(function () {
        if (i < data.length) {
          series.data.push({
            value: data[i].no_specific_provider,
          });
          legend.data.setAll([
            {
              name: `${capitalizeFirstLetter(data[0].provider)}, ${
                data[0].no_specific_provider
              }`,
              color: am5.color("#F7931D"),
            },
            {
              name: `${capitalizeFirstLetter(data[1].provider)}, ${
                data[1].no_specific_provider
              }`,
              color: am5.color("#2179BE"),
            },
            {
              name: `${capitalizeFirstLetter(data[2].provider)}, ${
                data[2].no_specific_provider
              }`,
              color: am5.color("#2A9ED2"),
            },
            {
              name: `${capitalizeFirstLetter(data[3].provider)}, ${
                data[3].no_specific_provider
              }`,
              color: am5.color("#38b449"),
            },
          ]);
          i++;
        } else {
          clearInterval(interval);
        }
      }, 500);
    },
    async getecosystem(series, legend) {
      try {
        setAuthToken();
        const response = await axios.get(ecosystem, config);
        this.ecodata = response.data;
        this.ecosystemdate = this.ecodata[0]?.To_Date_Query;
        this.animateSeries(this.ecodata, series, legend);
      } catch (error) {
        console.error("Error:", error);
      }
    },
    async getcashlessEnablement() {
      try {
        setAuthToken();
        const response = await axios.get(CashlessEnablement, config);
        this.cashless = response.data[response.data.length - 1];
      } catch (error) {
        console.error("Error:", error);
      }
    },
  },
};
</script>
<style scoped>
.chartview {
  height: 335px;
}
.table {
  border: 0.3px solid #394655;
}
.Firstdash-card {
  background-color: #15191e;
  border: 0.1px solid #15191e;
}
.table1 {
  height: 13.12rem;
}
.Cash-card {
  background-color: #262d36;
  height: 19rem;
  border: 1px solid #394655;
  border-radius: 0.8rem;
}

.head th {
  background-color: #0a65a3 !important;
  color: #ffffff;
  text-align: center;
  font-size: 1rem !important;
}

.table td {
  background-color: #15191e;
  color: #ffffff;
  text-align: right;
}

.table .trow {
  background-color: #15191e;
  color: #ffffff;
}

.table .trow1 {
  background-color: #15191e;
  color: #ffffff;
}
.heading-26 {
  font-size: 1.62rem !important;
  font-family: "Open Sans", sans-serif !important;
  color: #d2d2d2 !important;
}
#chartdiv {
  width: 100%;
  height: 15.6rem;
}

.am5-layer-30 {
  width: 41.56rem;
}

@media (min-width: 992px) {
  .Firstdash-card {
    height: 33vh !important;
  }

  .Cash-card {
    height: 31.5vh !important;
  }

  .heading-26 {
    font-size: 1rem !important;
  }
  .heading-22 {
    font-size: 0.8rem !important;
  }

  .head th {
    font-size: 0.6rem !important;
  }

  .table .trow {
    font-size: 0.6rem !important;
  }

  .table1 {
    height: 9rem !important;
  }

  .table td {
    font-size: 0.6rem !important;
  }

  #chartdiv {
    height: 6rem;
    margin-left: 0.5rem;
    margin-top: 1rem;
  }
}


@media (min-width: 1200px) {
  .heading-26 {
    font-size: 1rem !important;
    white-space: nowrap;
  }
  .heading-14 {
    font-size: 0.8rem !important;
  }
  .heading-22 {
    font-size: 0.9rem !important;
  }

  #chartdiv {
    height: 8rem;
    margin-left: 1.5rem;
    margin-top: 2rem;
  }

  .head th {
    font-size: 0.9rem !important;
  }

  .table .trow {
    font-size: 0.8rem !important;
  }

  .Cash-card {
    height: 13.6rem !important;
  }

  .table1 {
    height: 9rem !important;
  }
  .table td {
    font-size: 0.8rem !important;
  }

}

@media (min-width: 1400px) {
  .heading-14 {
    font-size: 0.8rem !important;
  }
  .heading-26 {
    font-size: 1.3rem !important;
  }

  .heading-22 {
    font-size: 1rem !important;
  }

  #chartdiv {
    height: 11rem;
    margin-left: 0.5rem;
    margin-top: 3rem;
  }

  .head th {
    font-size: 1rem !important;
  }

  .table .trow {
    font-size: 1rem !important;
  }

  .Cash-card {
    height: 16.8rem !important;
  }

  .table1 {
    height: 11rem !important;
  }
  .table td {
    font-size: 1rem !important;
  }
  .Firstdash-card {
    height: 36vh !important;
  }
}

</style>

